import { Component, Input } from '@angular/core';
import { Campanha } from '../../../../campanhas/campanhas/campanha';

@Component({
    selector: 'sgt-pedido-nao-liberado-card-info-bonificacao-excedente',
    templateUrl: './pedido-nao-liberado-card-info-bonificacao-excedente.component.html',
    styleUrls: ['./pedido-nao-liberado-card-info-bonificacao-excedente.component.less']
})
export class PedidoNaoLiberadoCardInfoBonificacaoExcedenteComponent {
    @Input() tipoVenda: number;
    @Input() dataNaoLiberado: Date;
    @Input() campanha: Campanha;
    @Input() valorRegraNaoLiberado: number;
    @Input() valorBonificacaoNaoLiberado: number;
    @Input() percBonificacaoMaximaNaoLiberado: number;
    @Input() percBonificacaoNaoLiberado: number;
    @Input() percBonificacaoExcedente: number;
}
